/**
 * @file Mapbox-style-helper.ts
 * @module MapboxStyleHelper
 * @description Palīgfunkcijas Mapbox stilu ģenerēšanai — krāsu manipulācija
 *              (hex uz RGB konversija, caurspīdīguma sajaukšana), filtru izteiksmju
 *              veidotāji un stilu īpašību formatēšana Mapbox GL specifikācijai.
 */

/**
 * Creates a Mapbox symbol layer for state road (V-class) shields.
 * Displays gray background with white text showing the road number.
 *
 * @param {string} label - Feature property name containing the road number
 * @returns {Object} Partial Mapbox layer specification for V-road shields
 */
export const SHIELD_V = (label: string) => ({
	type: "symbol",
	id: "road_shield_1",
	filter: ["all", ["any", ["==", ["geometry-type"], "MultiLineString"], ["==", ["geometry-type"], "LineString"]], ["==", ["get", "ac_type"], "V"]],
	layout: {
		"icon-image": "gray-box",
		"icon-rotation-alignment": "viewport",
		"symbol-placement": "point",
		"symbol-spacing": 500,
		"text-field": `{${label}}`,
		"text-font": ["Roboto Bold"],
		"text-offset": [0, 0.1],
		"text-rotation-alignment": "viewport",
		"text-size": 10,
		"icon-size": 0.9,
		"symbol-z-order": "auto",
		"text-pitch-alignment": "viewport",
		"symbol-avoid-edges": false,
		"icon-allow-overlap": true,
		"text-allow-overlap": true,
	},
	paint: {
		"icon-translate-anchor": "map",
		"text-color": "rgba(255, 255, 255, 1)",
	},
});

/**
 * Creates a Mapbox symbol layer for regional road (P-class) shields.
 * Displays blue background with white text showing the road number.
 *
 * @param {string} label - Feature property name containing the road number
 * @returns {Object} Partial Mapbox layer specification for P-road shields
 */
export const SHIELD_P = (label: string) => ({
	type: "symbol",
	id: "road_shield_2",
	filter: ["all", ["any", ["==", ["geometry-type"], "MultiLineString"], ["==", ["geometry-type"], "LineString"]], ["==", ["get", "ac_type"], "P"]],
	layout: {
		"icon-image": "blue-box",
		"icon-rotation-alignment": "viewport",
		"symbol-placement": "point",
		"symbol-spacing": 500,
		"text-field": `{${label}}`,
		"text-font": ["Roboto Bold"],
		"text-offset": [0, 0.1],
		"text-rotation-alignment": "viewport",
		"text-size": 10,
		"icon-size": 0.9,
		"symbol-z-order": "auto",
		"text-pitch-alignment": "viewport",
		"symbol-avoid-edges": false,
		"icon-allow-overlap": true,
		"text-allow-overlap": true,
	},
	paint: {
		"icon-translate-anchor": "map",
		"text-color": "rgba(255, 255, 255, 1)",
	},
});

/**
 * Creates a Mapbox symbol layer for motorway (A-class) shields.
 * Displays red background with white text showing the road number.
 *
 * @param {string} label - Feature property name containing the road number
 * @returns {Object} Partial Mapbox layer specification for A-road shields
 */
export const SHIELD_A = (label: string) => ({
	type: "symbol",
	id: "road_shield_3",
	filter: ["all", ["any", ["==", ["geometry-type"], "MultiLineString"], ["==", ["geometry-type"], "LineString"]], ["==", ["get", "ac_type"], "A"]],
	layout: {
		"icon-image": "red-box",
		"icon-rotation-alignment": "viewport",
		"symbol-placement": "point",
		"symbol-spacing": 500,
		"text-field": `{${label}}`,
		"text-font": ["Roboto Bold"],
		"text-offset": [0, 0.1],
		"text-rotation-alignment": "viewport",
		"text-size": 10,
		"icon-size": 0.9,
		"symbol-z-order": "auto",
		"text-pitch-alignment": "viewport",
		"symbol-avoid-edges": false,
		"icon-allow-overlap": true,
		"text-allow-overlap": true,
	},
	paint: {
		"icon-translate-anchor": "map",
		"text-color": "rgba(255, 255, 255, 1)",
	},
});
